import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
  TextInput,
  Select,
  FormLabel,
  FormHint,
} from "@zendesk/self-service-components";
import t from "@zendesk/client-i18n-tools";
import { STAFF, SIGNED_IN_USERS, USER_TYPE_NAME } from "../../../../constants";
import * as actions from "../../../../actions/userSegment";
import styles from "./index.css";

export class SetupStep extends Component {
  render() {
    const { name, userType, changeName, changeUserType } = this.props;

    return (
      <div className={styles.stepBody} data-test-id="step-body">
        <h2 className={styles.stepTitle}>
          {t("knowledge-user-segments.wizard.setupTitle")}
        </h2>
        <div>
          <TextInput
            testId="name-field"
            dir={t.dir}
            className={styles.formItem}
            label={t("knowledge-user-segments.wizard.nameLabel")}
            placeholder={t("knowledge-user-segments.wizard.namePlaceholder")}
            value={name}
            onChange={changeName}
          />

          <div className={styles.formItem}>
            <div>
              <FormLabel>
                {t("knowledge-user-segments.wizard.userTypeLabel")}
              </FormLabel>
            </div>
            <div>
              <FormHint>
                <span
                  dangerouslySetInnerHTML={{
                    __html: t("knowledge-user-segments.wizard.userTypeHint", {
                      learnMoreUrl: t(
                        "knowledge-user-segments.wizard.userTypeHintLearnMoreUrl"
                      ),
                    }),
                  }}
                />
              </FormHint>
            </div>

            <Select
              testId="user-type-field"
              dir={t.dir}
              className={styles.userTypeSelect}
              selected={
                userType ? (
                  t(USER_TYPE_NAME[userType])
                ) : (
                  <span className={styles.userTypePlaceholder}>
                    {t("knowledge-user-segments.wizard.pleaseSelect")}
                  </span>
                )
              }
              onChange={changeUserType}
            >
              <Select.Item value={SIGNED_IN_USERS}>
                {t(USER_TYPE_NAME[SIGNED_IN_USERS])}
              </Select.Item>
              <Select.Item value={STAFF}>
                {t(USER_TYPE_NAME[STAFF])}
              </Select.Item>
            </Select>
          </div>
        </div>
      </div>
    );
  }
}

SetupStep.propTypes = {
  name: PropTypes.string,
  userType: PropTypes.oneOf([STAFF, SIGNED_IN_USERS]),
  changeName: PropTypes.func,
  changeUserType: PropTypes.func,
};

const mapStateToProps = ({ userSegment }, { type }) => ({
  name: userSegment.name,
  userType: userSegment.userType,
});

const mapDispatchToProps = (dispatch, { type }) =>
  bindActionCreators({ ...actions }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(SetupStep);



// WEBPACK FOOTER //
// ./src/components/NewUserSegment/components/SetupStep/index.js